function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import _ from "lodash";
import { labelErrorClassName } from "../../../../helpers/errorUtils";
import { Label } from "reactstrap";
import styled from "styled-components";
import BadgedText from "../../general/BadgedText";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenNib } from "@fortawesome/pro-regular-svg-icons";
const StyledLabelSpan = styled.span`
  padding-right: .5rem;
`;

class TmLabel extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      initValue: this.props.value,
      isModified: false
    });

    _defineProperty(this, "isValueModified", () => {
      if (_.isNull(this.props.value) && this.state.initValue === '') {
        return false;
      }

      if (_.isObject(this.props.value)) {
        return !_.isEqual(this.props.value, this.state.initValue);
      }

      if (_.isEmpty(this.props.value) && !_.isEmpty(this.state.initValue)) {
        return true;
      }

      if (!_.isEmpty(`${this.props.value}`) && _.isEmpty(`${this.state.initValue}`)) {
        return true;
      }

      if (_.isEmpty(this.props.value) && _.isEmpty(this.state.initValue)) {
        return false;
      }

      return `${this.props.value}` !== `${this.state.initValue}`;
    });

    _defineProperty(this, "isValueNotModified", () => {
      if (_.isObject(this.props.value)) {
        return _.isEqual(this.props.value, this.state.initValue);
      }

      if (_.isEmpty(this.props.value) && _.isEmpty(this.state.initValue)) {
        return true;
      }

      return `${this.props.value}` === `${this.state.initValue}`;
    });

    _defineProperty(this, "renderModifiedIcon", () => {
      return /*#__PURE__*/React.createElement("abbr", {
        title: "modified"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPenNib
      }));
    });

    _defineProperty(this, "renderLabel", () => {
      if (this.props.hideLabel) {
        return /*#__PURE__*/React.createElement(React.Fragment, null);
      }

      const label = !!this.props.label ? this.props.label.replace(/\w+/g, _.capitalize) : _.startCase(this.props.field);

      if (this.props.required) {
        if (this.state.isModified && !this.props.disableEditHint) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BadgedText, {
            color: 'warning',
            badge: this.renderModifiedIcon()
          }, /*#__PURE__*/React.createElement(StyledLabelSpan, null, label), /*#__PURE__*/React.createElement("abbr", {
            title: "required"
          }, "*")));
        } else {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLabelSpan, null, label), /*#__PURE__*/React.createElement("abbr", {
            title: "required"
          }, "*"));
        }
      } else {
        if (this.state.isModified && !this.props.disableEditHint) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BadgedText, {
            color: 'warning',
            badge: this.renderModifiedIcon()
          }, label));
        } else {
          return /*#__PURE__*/React.createElement(React.Fragment, null, label);
        }
      }
    });

    _defineProperty(this, "render", () => {
      const {
        field,
        error,
        errorKey,
        className,
        hideLabel,
        hidelabel
      } = this.props;

      if (hideLabel || hidelabel) {
        return /*#__PURE__*/React.createElement(React.Fragment, null);
      }

      return /*#__PURE__*/React.createElement(Label, {
        className: `${labelErrorClassName(error, errorKey || field)} ${className}`,
        for: _.camelCase(field)
      }, this.renderLabel());
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.isValueModified() && !this.state.isModified) {
      this.setState({
        isModified: true
      });
    }

    if (this.isValueNotModified() && this.state.isModified) {
      this.setState({
        isModified: false
      });
    }
  }

}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {})(TmLabel);